// extracted by mini-css-extract-plugin
module.exports = {"root":"corrosive-waste-disposal-page_root__tjQ16"};